// components/icons/ContactIcon.tsx
import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    className?: string;
  }

const ContactIcon: React.FC<IconProps> = ({className, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            className={className}
            {...props} // Spread additional props for flexibility
        >
            <path
                d="M17.6154 7.74691C18.4314 7.9791 19 8.66914 19 9.46138V12.9655C19 13.8943 18.2182 14.6825 17.1723 14.7585C16.8585 14.7806 16.5446 14.801 16.2308 14.8174V17.3445L13.4615 14.8918C12.2117 14.8918 10.9748 14.8468 9.75077 14.7585C9.48431 14.7394 9.22511 14.6721 8.98923 14.5606M17.6154 7.74691C17.4728 7.70625 17.3253 7.68019 17.176 7.66924C14.7039 7.48747 12.2191 7.48747 9.74708 7.66924C8.70308 7.74609 7.92308 8.53342 7.92308 9.46138V12.9655C7.92308 13.6499 8.34769 14.2573 8.98923 14.5606M17.6154 7.74691V6.21476C17.6154 4.88946 16.552 3.74075 15.0677 3.56988C13.1577 3.3506 11.2337 3.24081 9.30769 3.24121C7.35538 3.24121 5.43262 3.35322 3.54769 3.56988C2.06338 3.74075 1 4.88946 1 6.21476V11.305C1 12.6303 2.06338 13.779 3.54769 13.9499C4.08031 14.0112 4.61569 14.0644 5.15385 14.1085V17.9577L8.98923 14.5606"
                stroke="currentColor" 
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ContactIcon;
